import { Reducer } from "redux";

import { PatientInformationByIdResponse } from "../models/api/Patient";
import { PatientInformationByIdDispatchTypes } from "../models/dispatchTypes/Patient";
import { PatientInformationByIdActionDispatchTypes } from "../constants/Patient";

const initialState: PatientInformationByIdResponse = {
  loading: false,
  response: {
    patientId: 0,
    referralId: 0,
    serviceRequestId: 0,
    patientName: "",
    patientFirstName: "",
    patientLastName: "",
    languagePreferenceValue: null,
    isPriorAuthIntakeStageComplete: false,
    isReAuthIntakeStageComplete: false,
    isPrioAuthCompleted: false,
    blobId: null,
    blobFileName: null,
    patientEligibilityId: 0,
    intakeStageId: 0,
    eligibilityPayerId: "",
    eligibilityPayerName: "",
    ahcccsId: null,
    memberInfo: {
      dateOfBirth: "",
      gender: "",
      subscriberId: "",
      medicareBeneficiaryIdentifier: "",
      phoneNo: "",
      healthPlan: "",
      effectiveDate: "",
      effectiveThrough: "",
      dateOfIssuance: "",
      benefitPlan: "",
      product: "",
      insuranceState: "",
      languageId: null,
      languageName: null,
      extension: null,
      cellPhone: null,
      accommodationId: null,
      accommodationName: null,
      alternatePhone: null,
      contractIdPbp: null,
      groupPlanId: null,
      relationshipTypeId: null,
      subscriberFirstName: null,
      subscriberLastName: null,
      subscriberDateOfBirth: null,
      subscriberGender: null,
    },
    addressInfo: {
      residentialAddress: "",
      mailingAddress: "",
      patientMailingAddress: {
        streetName1: "",
        streetName2: null,
        county: "",
        city: "",
        patientState: "",
        zipCode: "",
        latitude: 0.0,
        longitude: 0.0,
        addressTypeId: 3,
        country: "",
      },
      patientResidentialAddress: {
        streetName1: "",
        streetName2: null,
        county: "",
        city: "",
        patientState: "",
        zipCode: "",
        latitude: 0,
        longitude: 0,
        addressTypeId: 1,
        country: "",
      },
    },
    primaryPhysician: {
      referralId: 0,
      referralPhysicianDetailId: 0,
      physicianId: 0,
      physicianName: "",
      physicianNpiId: "",
      phoneExt: null,
      phoneNo: "",
      taxId: null,
      streetName1: "",
      streetName2: null,
      fax: null,
      county: "",
      city: "",
      physicianState: "",
      zipCode: "",
      physicianTypeId: 1,
      physicianAddress: null,
      fullNameCreated: "",
    },
    emergencyContact: [
      {
        contactName: "",
        relationId: 1,
        phoneNo: "",
        extension: "",
        relationshipName: "",
        preferredLanguage: "",
      },
    ],
    isManual: false,
    isPriorAuthCreated: true,
    authorizationTypeId: 0,
    sendApprovedAuthTo: 0,
    secondaryEmailAddress: ""
  },
  error: null,
};

const PatientInformationByIdReducer: Reducer<
  PatientInformationByIdResponse,
  PatientInformationByIdDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case PatientInformationByIdActionDispatchTypes.PATIENT_INFORMATION_BY_ID_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case PatientInformationByIdActionDispatchTypes.PATIENT_INFORMATION_BY_ID_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case PatientInformationByIdActionDispatchTypes.PATIENT_INFORMATION_BY_ID_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PatientInformationByIdReducer;
